import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "d-none d-lg-block mx-auto w-275px w-md-50 w-xl-250px mb-10 mb-lg-20",
  src: "media/logos/lpcv_es_bnn.png",
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7" }
const _hoisted_5 = { class: "d-none d-lg-block text-white fs-base text-center w-xl-400px" }
const _hoisted_6 = { class: "d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-2" }
const _hoisted_7 = { class: "d-flex flex-center flex-column flex-lg-row-fluid" }
const _hoisted_8 = { class: "w-lg-500px w-250px py-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-wrap px-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100",
        style: _normalizeStyle(`background-image: url('media/misc/auth-bg-primary.png');filter: hue-rotate(0deg)`)
      }, [
        _hoisted_3,
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("authTitulo")), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("authDescripcion")), 1)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_view)
        ])
      ]),
      _hoisted_9
    ])
  ]))
}